/** @module Merchandising/SecondaryDisplay/SecondarySelectionSwitchboard */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/Deferred",
	"csi/_base/storage",
	"csi/_base/underscore",
	"csi/def/Relationship",
	"csi/reflection",
	"csi/state",
	"csi/toolbar/MultiSelectSwitchboard",
	"csi/xml",
	"csi/xml/Query",
	"Merchandising/SecondaryDisplay/CustomViewSecondaryDisplayOptions",
], function(declare, lang, csiDeferred, storage, _, Relationship, reflection, state, MultiSelectSwitchboard, xml, Query, CustomViewSecondaryDisplayOptions) {

	var secondaryTypePropKey = "activeMerchSecondaryType";
	var filterSettingsPropKey = "filterSettings";

	return declare(MultiSelectSwitchboard, {
		SECONDARY_FILTER_LEVEL: "1",

		idViewProperty: "activeMerchSecondaries",
		refreshStoreOptions: true,
		switchboardPath: "Child:PlanSecondary",

		// delay initialization is set to wait for the custom view filters to be set
		bDelayInitialization: true,

		// Query: query used in secondaries store - used as unique identifier to know if store needs to be refreshed
		_storeQuery: null,

		/**
		 * @override
		 * Add NONE and ALL option to select widget based on the ShowAllSecondaries boolean on plan
		 */
		onSelectParams: function(/*Object*/params) {
			const view = this.getView();
			const node = view.getViewNode();
			const level = node && view.cacheView.get(node.__Parent__);
			const plan = level && view.cacheView.get(level.Plan);
			if (plan && !plan.ShowAllSecondaries) {
				params.addItemAll = true;
				params.defaultClearText = "SelectNone";
			} else {
				params.defaultClearText = "SelectAll";
			}

		},

		/**
		 * Refresh store if the subtype changed
		 * @param {string} attr
		 * @param {string} oldVal
		 * @param {string} newVal
		 */
		_onWatchViewProperty: function(attr, oldVal, newVal) {
			if (!_.isEqual(oldVal || [], newVal || [])) {
				this.refreshStore(newVal);
			}
		},

		/**
		 * Return true if the custom view option for secondary display type is not 0 (disabled) and the matrix is selected
		 * @return {boolean}
		 */
		canShowPlugin: function() {
			this.set("value", this.getView().get("activeMerchSecondaries"));
			return this.getView().isShowingSecondaries();
		},

		/**
		 * Set two watches to react to the season and secondary type switchboards
		 */
		postCreate: function() {
			var self = this;

			function _onChange() {
				self.refreshStore(self.getViewPropertyValue());
			}


			this.getView().watch(secondaryTypePropKey, _onChange);
			this.getView().watch(filterSettingsPropKey, _onChange);

			this.inherited(arguments);
		},

		/**
		 * Refresh store for secondaries switchboard - if printing, then nothing to do; otherwise, only refresh if query
		 * can fully be specified and has changed from before
		 * @param {any} [value]
		 * @param {boolean} [bDefault]
		 */
		refreshStore: function(value, bDefault) {
			const view = this.getView();
			const ctx = view.getContext(view.getViewURL());
			if (ctx.bPrint) {
				return;
			}

			const subtype = view.get(secondaryTypePropKey);
			const node = view.getViewNode();

			if (!node || !subtype) {
				return;
			}

			var q = new Query()
				.RefAttr("Season", xml.OP_EQUALS, node.Season)
				.RefAttr("Subtype", xml.OP_EQUALS, subtype, "Child:__Parent__")
				.RefAttr("__Parent__", xml.OP_EQUALS, node.__Parent__, "Child:__Parent__");

			this._resolveDeferred();

			this._storeQuery = q;

			this.inherited(arguments);
		},

		/**
		 * Hide if printing
		 */
		validatePlugin: function(ctx) {
			return !ctx.bPrint;
		},

		/**
		 * Return store options to get secondaries for current season, subtype, and filters
		 * @param {string} url
		 * @param {Relationship} [r]
		 * @return {Object} - modified store options
		 */
		_getStoreOptions: function(url, r) {
			if (!this._storeQuery) {
				return null;
			}

			r = r || lang.mixin(new Relationship(), {
				m_typeNode: "MerchSecondaryVersion",
				m_query: this._storeQuery
			});

			var options = this.inherited(arguments, [url, r]);
			if (options) {
				options.request.addParameter("Qry.Value.Path", reflection.PATH_PARENT);
			}

			return options;
		},

		_onDelayedStart: function() {
			// Do nothing: store will be initialized _onChange()
		}
	});
});